export default __webpack_public_path__ + "static/media/women_cut.623b1737.png";